import { FileText, FileSpreadsheet, FileArchive, File as FileIcon, Image as ImageIcon } from 'lucide-react';

// Ek türüne göre ikon + renk
export const getFileMeta = (attachment) => {
  const name = (attachment.filename || '').toLowerCase();
  const type = attachment.content_type || '';
  if (type === 'application/pdf' || name.endsWith('.pdf')) {
    return { Icon: FileText, cls: 'bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400' };
  }
  if (/\.(xlsx?|csv|ods)$/.test(name) || type.includes('spreadsheet') || type.includes('excel')) {
    return { Icon: FileSpreadsheet, cls: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-400' };
  }
  if (/\.(docx?|odt|rtf)$/.test(name) || type.includes('word')) {
    return { Icon: FileText, cls: 'bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400' };
  }
  if (type.startsWith('image/')) {
    return { Icon: ImageIcon, cls: 'bg-violet-50 text-violet-600 dark:bg-violet-500/15 dark:text-violet-400' };
  }
  if (/\.(zip|rar|7z|tar|gz)$/.test(name)) {
    return { Icon: FileArchive, cls: 'bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400' };
  }
  return { Icon: FileIcon, cls: 'bg-slate-100 text-slate-600 dark:bg-slate-500/20 dark:text-slate-300' };
};
